import type { Serwist } from '@serwist/window';
import { useDispatch } from 'react-redux';

import { logger } from '@/config/logger';
import { displayInfoMessage } from '@/modules/messages/services/actions';
import { waitUntilPageLoaded } from '@/utilities/page';

export function useRegister() {
    const dispatch = useDispatch();

    return async function register(serwist: Serwist) {
        // Prevent registering service worker during page load -> it slow down the page load since it pre-fetches all the assets
        await waitUntilPageLoaded();

        // eslint-disable-next-line compat/compat
        const registration = await globalThis.navigator.serviceWorker.getRegistration('/');

        serwist.addEventListener('installed', () => {
            if (!registration) {
                dispatch(
                    displayInfoMessage({
                        message: { id: 'service-worker.installed' },
                        options: { duration: 5 },
                    }),
                );
            }

            logger.debug('Serwist installed. Service worker is ready. 🟢');
        });

        await serwist.register();
    };
}
